import { HiExclamationTriangle } from "react-icons/hi2";
import { Card } from "./card";
import { EnhancedAccount } from "src/hooks/use-account-enhanced";

export function HelpDeskPrompt({
    pageName,
    enhancedAccount,
}: {
    pageName: string;
    enhancedAccount: EnhancedAccount;
}) {
    return (
        <div className="h-full flex items-center justify-center">
            <Card>
                <div className="card items-center text-center">
                    <div className="flex flex-col items-center mb-8 w-lg">
                        <div className="bg-gray-200 p-5 rounded-full mb-4">
                            <HiExclamationTriangle className="w-8 h-8 text-[#ac2226]" />
                        </div>
                        <h2 className="text-xl font-bold text-gray-700 mb-2">
                            Missing Employee ID
                        </h2>
                        <p className="text-gray-600">
                            Your profile is missing a required Employee ID.
                            <br />
                            Contact Helpdesk to resolve this.
                        </p>
                    </div>

                    <div className="card-actions">
                        <a
                            href={`mailto:helpdesk@m-v-t.com?subject=${encodeURIComponent("Missing Employee ID in Azure AD Profile")}&body=${encodeURIComponent(`Hello,\n\nMy Azure AD profile is missing the Employee ID property, which is required to use the ${pageName} module in MVTE Center.\n\nPlease update my AD profile with the correct Employee ID.\n\nName: ${enhancedAccount.account?.name ?? "Unknown"}\nEmail: ${enhancedAccount.account?.username ?? "Unknown"}\n\nThank you.`)}`}
                            className="btn btn-error btn-sm text-white"
                        >
                            Contact Helpdesk
                        </a>
                    </div>
                </div>
            </Card>
        </div>
    );
}
